export default "__VITE_ASSET__DYJINakn__"